import React, { useState, useEffect } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { message, DatePicker } from "antd";
import PageHeader from "../../Routes/PageHeader";
import { API } from "../../Config";
import LoadingBox from "../../Components/LoadingBox";
import DataTable from "./DataTable";
import FormModalContra from "./FormModalContra";
import ViewPage from "./ViewPage";
import { GET, POST, PUT, DELETE } from "../../Config/ApiRequests";

const { RangePicker } = DatePicker;

const ContraVoucher = () => {
  const { page_mode } = useParams();
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [indicator, setIndicator] = useState(false);
  const [form, setForm] = useState(false);
  const [mode, setMode] = useState("post");
  const [head, setHead] = useState("");
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState({});
  const [item, setItem] = useState({});
  const [accounts, setAccounts] = useState([]);
  const [columnsVisible, setColumnsVisible] = useState({
    page: "Contra Voucher",
    short: "CV",
    accounts: true,
  });
  const [dateRange, setDateRange] = useState([null, null]);
  const [viewPage, setViewPage] = useState(false);
  const [viewId, setViewId] = useState(null);

  useEffect(() => {
    if (page_mode === "CV") {
      setHead("");
      const params = new URLSearchParams(location.search);
      const page = Number(params.get("page")) || 1;
      const take = Number(params.get("take")) || 10;
      const dateFrom = params.get("dateFrom") || "";
      const dateTo = params.get("dateTo") || "";
      loaddata(page, take, dateFrom, dateTo);
      AccountsDropdown();
    } else {
      message.error("Invalid page mode");
      setHead("");
      setLoading(false);
    }
  }, [location.search, page_mode]);

  const loaddata = async (p, t, dateFrom = "", dateTo = "") => {
    try {
      let url = `${API.CONTRA_VOUCHER_LIST}?page=${p}&take=${t}`;
      if (dateFrom) url += `&dateFrom=${dateFrom}`;
      if (dateTo) url += `&dateTo=${dateTo}`;
      const response = await GET(url);
      const payload = response || {};
      setData(payload.data || []);
      setMeta(payload.meta || {});
    } catch (error) {
      console.error("Error loading data:", error);
      message.error("Oops. Something went wrong");
      setData([]);
      setMeta({});
    } finally {
      setLoading(false);
      setIndicator(false);
    }
  };

  const AccountsDropdown = () => {
    GET(`${API.CHART_OF_ACCOUNTS_LIST}/child_accounts`)
      .then((res) => {
        setAccounts(Array.isArray(res) ? res : []);
      })
      .catch((error) => {
        console.error("Error loading accounts:", error);
        message.error(error.message);
        setAccounts([]);
      });
  };

  const updateUrl = (page, take, dateFrom = "", dateTo = "") => {
    const params = new URLSearchParams();
    if (page > 1) params.set("page", page);
    if (take !== 10) params.set("take", take);
    if (dateFrom) params.set("dateFrom", dateFrom);
    if (dateTo) params.set("dateTo", dateTo);
    history.replace(params.toString() ? `${location.pathname}?${params}` : location.pathname);
  };

  const pagination = (page, pageSize) => {
    window.scrollTo(0, 0);
    setIndicator(true);
    const params = new URLSearchParams(location.search);
    const dateFrom = params.get("dateFrom") || "";
    const dateTo = params.get("dateTo") || "";
    updateUrl(page, pageSize, dateFrom, dateTo);
  };

  const handleDateChange = (dates) => {
    setDateRange(dates);
    const params = new URLSearchParams(location.search);
    const take = Number(params.get("take")) || 10;
    const dateFrom = dates?.[0] ? dates[0].format("YYYY-MM-DD") : "";
    const dateTo = dates?.[1] ? dates[1].format("YYYY-MM-DD") : "";
    updateUrl(1, take, dateFrom, dateTo);
  };

  const reload = () => {
    const params = new URLSearchParams(location.search);
    const page = Number(params.get("page")) || 1;
    const take = Number(params.get("take")) || 10;
    loaddata(page, take);
    setMode("post");
    setItem({});
    setForm(false);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 50);
  };

  const AddItem = () => {
    console.log("AddItem clicked: Opening modal");
    setMode("post");
    setItem({});
    setForm(true);
    setLoading(true); // Set loading to true when opening the modal
    setTimeout(() => {
      setLoading(false); // Simulate loading completion after 1 second
    }, 50);
  };

  const UpdateItem = (item) => {
    console.log("UpdateItem:", item);
    setMode("put");
    setItem(item);
    setForm(true);
    setLoading(true); // Set loading to true when opening the modal
    setTimeout(() => {
      setLoading(false); // Simulate loading completion after 1 second
    }, 50);
  };

  const ViewItem = (item) => {
    setViewId(item.id);
    setViewPage(true);
  };

  const handleBackFromView = () => {
    setViewPage(false);
    setViewId(null);
  };

  const DeleteItem = async (item) => {
    setIndicator(true);
    try {
      await DELETE(`${API.CONTRA_VOUCHER_ACTIONS}/${item.id}`);
      message.success("Deleted Successfully");
      reload();
    } catch (error) {
      message.error(error.message);
      console.error("Error deleting item:", error);
    } finally {
      setIndicator(false);
    }
  };

  const saveContra = async (values, ledgerFrom, ledgerTo) => {
    setIndicator(true);
    const obj = {
      ledger_from: ledgerFrom || "",
      description: values.description || "",
      ledger_to: ledgerTo || "",
      voucher_date: values.voucher_date ? values.voucher_date : "",
      amount: Number(values.amount) || 0,
    };

    try {
      await POST(API.CONTRA_VOUCHER_ACTIONS, obj);
      message.success("Created Successfully");
      reload();
    } catch (error) {
      message.error(error.message);
      console.error("Error creating contra:", error);
    } finally {
      setIndicator(false);
    }
  };

  const updateContra = async (itemId, values, ledgerFrom, ledgerTo) => {
    setIndicator(true);
    const obj = {
      ledger_from: ledgerFrom || "",
      description: values.description || "",
      ledger_to: ledgerTo || "",
      voucher_date: values.voucher_date ? values.voucher_date : "",
      amount: Number(values.amount) || 0,
    };

    try {
      await PUT(`${API.CONTRA_VOUCHER_ACTIONS}/${itemId}`, obj);
      message.success("Updated Successfully");
      reload();
    } catch (error) {
      message.error(error.message);
      console.error("Error updating contra:", error);
    } finally {
      setIndicator(false);
    }
  };

  return (
    <div>
      <PageHeader
        PageName={head}
        breadScrum={`Admin / ${columnsVisible.page}`}
        RightButton={` New ${columnsVisible.page}`}
        RightClcik={AddItem}
        loaderculos={indicator}
      />
      <div style={{ marginBottom: 16 }}>
        <RangePicker
          value={dateRange}
          onChange={handleDateChange}
          format="DD/MM/YYYY"
          placeholder={["Start Date", "End Date"]}
          allowClear
        />
      </div>
      {loading ? (
        <LoadingBox />
      ) : viewPage ? (
        <ViewPage contraId={viewId} onBack={handleBackFromView} />
      ) : (
        <div>
          <DataTable
            columnsVisible={columnsVisible}
            meta={meta}
            data={data}
            view={ViewItem}
            update={UpdateItem}
            delete={DeleteItem}
            PageOnchange={pagination}
          />
          <FormModalContra
            page_mode={page_mode}
            setLoading={setLoading}
            accounts={accounts}
            head={head}
            item={item}
            mode={mode}
            visible={form}
            columnsVisible={columnsVisible}
            onSave={saveContra}
            onUpdate={updateContra}
            onChange={reload}
            onClose={() => {
              setForm(false);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ContraVoucher;
